import { getSocket } from "../../utils/socket/socketClient";
import { store } from "../store";
import { resetPos } from "./posSlice";

export const initializePosSocketListeners = () => {
  const socket = getSocket();

  socket.on("sale_completed", () => {
    store.dispatch(resetPos());
  });
};
